import { useEffect } from 'react'

import _ from 'lodash'
import { Tick02Icon } from '@hugeicons/react'
import { BrowserView, MobileView } from 'react-device-detect'

import { ScrollMenu } from '@/shared/ui/ScrollMenu'

export const AvatarEditorColorSelector = ({
  colors,
  selectedOption,
  selectedColor,
  onSelectColor
}) => {
  useEffect(() => {
    if (!selectedColor && colors && colors.length == 1)
      onSelectColor(selectedOption.slug, colors[0].slug)
  }, [colors, selectedColor])

  if (!colors || colors.length == 1) return <></>
  return (
    <div id="avatar-editor-color-selector">
      <BrowserView>
        <div className="flex items-center flex-wrap gap-3 p-6 lg:p-8">
          <span className="shrink-0 font-bold text-base">Cores:</span>

          {colors.map((color, index) => {
            const isSelected = selectedColor === color.slug
            let colorHex = color.colors[0]

            return (
              <button
                key={`color-${index}`}
                className={`relative w-[35px] h-[35px] rounded-full border-2 cursor-pointer bg-transparent p-0 animate__animated animate__fadeInRight animate__faster ${
                  isSelected ? 'border-success' : 'border-gray-300'
                }`}
                onClick={() =>
                  !isSelected && onSelectColor(selectedOption.slug, color.slug)
                }
                style={{ backgroundColor: colorHex }}
              >
                {isSelected && (
                  <span className="absolute w-[15px] h-[15px] flex items-center justify-center rounded-full bg-success top-full right-0 translate-x-1/2 -translate-y-1/2">
                    <Tick02Icon variant="solid" size={12} className="text-white" />
                  </span>
                )}
              </button>
            )
          })}
        </div>
      </BrowserView>
      <MobileView>
        <ScrollMenu className="flex gap-1 pt-6 pb-3">
          {colors.map((color, index) => {
            const isSelected = selectedColor === color.slug
            let colorHex = color.colors[0]

            return (
              <button
                key={`color-${index}`}
                className={`relative w-[35px] h-[35px] mb-2 rounded-full border-2 cursor-pointer bg-transparent p-0 animate__animated animate__fadeInRight animate__faster ${
                  isSelected ? 'border-success' : 'border-gray-300'
                }`}
                onClick={() =>
                  !isSelected && onSelectColor(selectedOption.slug, color.slug)
                }
                style={{ backgroundColor: colorHex }}
              >
                {isSelected && (
                  <span className="absolute w-[15px] h-[15px] flex items-center justify-center rounded-full bg-success top-full right-0 translate-x-1/2 -translate-y-1/2">
                    <Tick02Icon variant="solid" size={12} className="text-white" />
                  </span>
                )}
              </button>
            )
          })}
        </ScrollMenu>
      </MobileView>
    </div>
  )
}
